import React from 'react';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { stateValueFormatter } from 'utils/valueFormatters';
import { IconCycle } from 'utils/icons';
import { DialedDigitExtractionServer } from 'data/dialedDigitExtractionServer/dialedDigitExtractionServer.types';

import './dialed-digit-extraction-server-status-cell-renderer.scss';

type Props = Partial<ICellRendererParams>;

export default function DialedDigitExtractionServerCellRenderer({
  data = {},
  ...rest
}: Props): JSX.Element {
  const {
    asstate
  } = data as DialedDigitExtractionServer;

  let className = 'status ';

  if (asstate === 'ACTIVE') {
    className += 'active';
  } else if (asstate === 'INACTIVE') {
    className += 'inactive';
  } else if (asstate === 'PARTIALLY_ACTIVE') {
    className += 'partially-active';
  }

  let value = asstate
  value = stateValueFormatter({ ...(rest as ICellRendererParams), value, data });

  return (
    <span className="dialed-digit-extraction-server-status-cell-renderer">
      <span className={className} title={value}><IconCycle /></span>
      {value}
    </span>
  );
}
